/**
 * Builds auth URLs with optional redirect so users return to the page they came from after login/register.
 * @param {{ pathname: string, search?: string }} location - from useLocation()
 * @returns {{ loginPath: string, registerPath: string }}
 */
export function getAuthRedirectPaths(location) {
  const { pathname, search = '' } = location || {};
  const isAuthPage = pathname === '/auth/login' || pathname === '/auth/register';
  const redirect = !isAuthPage && pathname ? encodeURIComponent(pathname + search) : '';

  return {
    loginPath: redirect ? `/auth/login?redirect=${redirect}` : '/auth/login',
    registerPath: redirect ? `/auth/register?redirect=${redirect}` : '/auth/register',
  };
}

/**
 * Validates redirect param to prevent open redirects. Only allows same-origin paths (starting with /, no protocol).
 * @param {string} redirect - value from URL search params
 * @returns {string} safe path to navigate, or '/' if invalid
 */
export function getSafeRedirectTarget(redirect) {
  if (!redirect || typeof redirect !== 'string') return '/';
  const decoded = decodeURIComponent(redirect.trim());
  if (decoded === 'payment') return 'payment'; // special case: caller may navigate to /pricing
  if (decoded.startsWith('/') && !decoded.startsWith('//')) return decoded;
  return '/';
}
